import { useEffect } from 'react';

import { emptyFn } from '@trader/constants';

export const useBeforeUnload = (): void => {
  useEffect(() => {
    const unloadCallback = () => {
      // TODO: think if we need it
      // event.preventDefault();
      // event.returnValue = '';
      // return;
    };

    window.addEventListener('beforeunload', unloadCallback);
    return () => {
      window.removeEventListener('beforeunload', unloadCallback);
      window.removeEventListener('pagehide', emptyFn);
    };
  }, []);
};
